import React from 'react';
import { Field, ButtonRadio, Select } from '../Common';

const organization = {
    id: '',
    idBeneficiaire: '',
    name: '',
    tel: '',
    email: '',
    error: {
        name: '',
        tel: '',
        email: '',
    }
}

export default class organizationsToContactFrom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addOrganization: this.props.organizationsToContact && this.props.organizationsToContact.length > 0 ? '1': '0',
            disabled: this.props.organizationsToContact && this.props.organizationsToContact.length > 0 ? false : true,
            organizationsToContact: this.props.organizationsToContact && this.props.organizationsToContact.length > 0 ? this.props.organizationsToContact : [{ ...organization, id :0 }],
            error: {
                name: '',
                address: '',
                zipCode: '',
                city: '',
                date: '',
                country: '',
                telephone: '',

            }
        }
    }

    handleOnChange(key, e) {
        const value = e.target.value;
        this.setState(() => ({ [key]: value }));
        if (value === '0') {
            const id = this.state.organizationsToContact.length - 1;
            if (this.state.organizationsToContact !== '') {
                const organizationsToContact = this.state.organizationsToContact.filter(x => x.id !== '');
                this.setState(() => ({
                    organizationsToContact,
                    disabled: true
                }));
            }

        }
        else if (value === '1') {
            const id = this.state.organizationsToContact.length + 1;
            if (this.state.organizationsToContact !== '') {
                const organizationsToContact = this.state.organizationsToContact.filter(x => x.id !== '');
                if (organizationsToContact && !organizationsToContact.length){
                	const newOrganization = {
                            ...organization,
                            id: this.state.organizationsToContact.length
                        }
                	organizationsToContact.push(newOrganization);
                }
                this.setState(() => ({
                    organizationsToContact,
                    disabled: false
                }));
            }

        }
    }
    onOrganizationChange(key, e) {
        const index = e.target.name;
        const value = e.target.value;
        this.setState(prevState => ({
            organizationsToContact: prevState.organizationsToContact.map(
                obj => (obj.id == index ? { ...obj, [key]: value } : obj)
            )
        }));
    }
    addOrganization = () => {
        const id = this.state.organizationsToContact.length;
        const newOrganization = {
            ...organization,
            id

        }
        this.setState(prevState => ({
            organizationsToContact: [...prevState.organizationsToContact, newOrganization]
        }));
    }
    removeOrganization = (id) => {
        const _id = id;
        const organizationsToContact = this.state.organizationsToContact.filter(({ id }) => id !== _id);
        this.setState(() => ({ organizationsToContact }));
    }
    go = (people) => {
        let submit = true;
        if (this.state.addOrganization === '1') {
            people.map((obj) => {
                if (!obj.name
                    || !obj.tel
                    || !obj.email
                )
                    submit = false;
            })
        }
        return submit;
    }
    onSubmit = (e) => {
        e.preventDefault();
        if (this.state.addOrganization === '1') {
            this.setState(prevState => ({
                organizationsToContact: prevState.organizationsToContact.map((obj) => {
                    const name = (!obj.name) ? ' is-invalid' : '';
                    const tel = (!obj.tel) ? ' is-invalid' : '';
                    const email = (!obj.email) ? ' is-invalid' : '';
                    obj.error = {
                        ...obj.error,
                        name,
                        tel,
                        email,
                    }
                    return obj;
                })
            }));

            const organizationsToContact = this.state.organizationsToContact;
            const submit = this.go(organizationsToContact);
            if (submit) {
                this.props.onOrganizationsToContactSubmit(organizationsToContact);
            }
        }
        else {
            const organizationsToContact = '';
            this.setState(() => ({
                organizationsToContact,
            }));
            const submit = this.go(organizationsToContact);
            if (submit) {
                this.props.onOrganizationsToContactSubmit(organizationsToContact);
            }
        }
    }

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <p>
                    Souhaitez-vous informer un ou plusieurs organismes de votre décès ?
                </p>
                <div className="alternate-radio-buttons">
                    <ButtonRadio
                        type="radio"
                        _id="addOrganization1"
                        name="addOrganization"
                        value="1"
                        checked={this.state.addOrganization == "1"}
                        onChange={this.handleOnChange.bind(this, 'addOrganization')}
                        label="Oui"
                    />
                    <ButtonRadio
                        type="radio"
                        _id="addOrganization2"
                        name="addOrganization"
                        value="0"
                        checked={this.state.addOrganization == "0"}
                        onChange={this.handleOnChange.bind(this, 'addOrganization')}
                        label="Non"
                    />
                </div>
                {!this.state.disabled &&
                	<h4>Je souhaite que ces organismes soient informés de mon décès : </h4>
                }
                
                {!this.state.disabled && this.state.organizationsToContact && this.state.organizationsToContact.map((organization, i) =>
                    <div className="row" key={i}>
                        {/* {i === 0 &&
                            // DISPLAY PHOTO IF FIRST PERSON
                            <div className="col-sm-4">
                                <img src='/images/li-lg.png' alt="image profil" className="img-thumbnail _lg" />
                                <img src='/images/block3.png' alt="image profil" className="img-thumbnail _sm" />
                            </div>
                        } */}
                        <div className="col-sm-12 form-container">
                            <div className="first-person">
                                {i > 0 &&
                                    <div className="delete-item-button" onClick={() => this.removeOrganization(organization.id)} >&nbsp;Supprimer&nbsp;</div>
                                }
                                <h4 className="top-title"><div className="icon-title _person"></div>Organisme {i + 1} </h4>
                                <div className="row">
                                    <div className="col">
                                        <Field
                                            label="Nom *"
                                            type="text"
                                            name={organization.id}
                                            _className={"form-control address " + organization.error.name}
                                            value={organization.name}
                                            onChange={this.onOrganizationChange.bind(this, "name")}
                                            error={organization.error.name}
                                        />
                                        <Field
                                            label="Téléphone *"
                                            type="text"
                                            name={organization.id}
                                            _className={"form-control address " + organization.error.tel}
                                            value={organization.tel}
                                            onChange={this.onOrganizationChange.bind(this, "tel")}
                                            error={organization.error.tel}
                                        />
                                        <div className="required-txt _screen"> * Champs obligatoires</div>
                                    </div>
                                    <div className="col">
                                        <Field
                                            label="Email *"
                                            type="text"
                                            name={organization.id}
                                            _className={"form-control address " + organization.error.email}
                                            value={organization.email}
                                            onChange={this.onOrganizationChange.bind(this, "email")}
                                            error={organization.error.email}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="required-txt _mobile"> * Champs obligatoires</div>
                            <div className="separator-list"></div>
                        </div>
                    </div>

                )}
                <div className="col-sm-12  form-container align-center">
	                {!this.state.disabled &&
	                	<button type="button" className="btn btn-outline-primary btn-sm btn-icon" disabled={this.state.disabled} onClick={this.addOrganization}><div className="icon-button">+</div>  Ajouter une organisme  </button>
	                }
                    <div className="button-container">
                    <button type="submit" className="btn btn-outline-primary" onClick={this.props.back}>{"< Precedent"}</button>
                        <button type="submit" className="btn btn-primary">Enregistrer</button>
                    </div>
                </div>
            </form>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/ObituaryPage/OrganizationsToContact.js